export const relatoriosInitialState = {
  //ANALISE DE VENDAS
  analiseDeVendasRelatorio: [],
  analiseDeVendasRelatorioResumo: [],
  analiseDeVendasPDF: [],
};
